<template>
  <span>You successfully created a new task based on your scheme and study</span>
</template>

<script>
export default {
  name: "created-task"
};
</script>